import React from 'react';

const Locations = () => {
  return (
    <section id="locais" className="py-16 bg-neutral-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-sans font-bold mb-2 text-primary">Locais de Atendimento</h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça nossas unidades onde são realizadas as mentorias e atendimentos
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mx-auto max-w-4xl">
          <div className="bg-neutral-lightest p-6 rounded-lg shadow-medium hover:shadow-strong transition-shadow duration-300">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-primary text-center">Barra da Tijuca</h3>
            <p className="text-gray-700 text-center mb-4">
              Av. João Cabral de Mello Neto, 850<br />
              Barra da Tijuca<br />
              Rio de Janeiro - RJ<br />
              22775-057
            </p>
            <div className="text-center">
              <a 
                href="https://maps.google.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block text-secondary hover:text-secondary-dark font-medium transition-colors duration-300"
              >
                Ver no mapa
              </a>
            </div>
          </div>
          
          <div className="bg-neutral-lightest p-6 rounded-lg shadow-medium hover:shadow-strong transition-shadow duration-300">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-primary text-center">Leblon</h3>
            <p className="text-gray-700 text-center mb-4">
              Rua Almirante Guilhem, 366<br />
              5º andar, 8º andar e 9º andar<br />
              Leblon, Rio de Janeiro - RJ<br />
              22440-000
            </p>
            <div className="text-center">
              <a 
                href="https://maps.google.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block text-secondary hover:text-secondary-dark font-medium transition-colors duration-300"
              >
                Ver no mapa
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-neutral-lightest p-8 rounded-lg shadow-medium">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-2/3 mb-8 md:mb-0 md:pr-8">
              <h3 className="text-2xl font-sans font-bold mb-4 text-primary">Agende uma videochamada</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Quer tirar todas as suas dúvidas antes de se inscrever na mentoria ou no curso? Agende uma videochamada com nossa equipe e entenda, de forma clara e personalizada, como funciona a nossa metodologia e como essa experiência pode transformar sua prática clínica.
              </p>
            </div>
            <div className="md:w-1/3 flex justify-center">
              <a 
                href="https://wa.me/qr/2AH46FUENFT7P1" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
              >
                Agendar Videochamada
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
